import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as SgGolfClubLogo } from 'assets/svg/sg-golf-club-standard.svg';
import { ReactComponent as SgGolfClubReverse } from 'assets/svg/sg-golf-club-reverse.svg';
import { ReactComponent as SgGolfClubLight } from 'assets/svg/sg-golf-club-light.svg';
import { ReactComponent as GolftimeClubLogo } from 'assets/svg/golftime-club-standard.svg';
import { ReactComponent as GolftimeClubReverse } from 'assets/svg/golftime-club-reverse.svg';
import { ReactComponent as GolftimeClubLight } from 'assets/svg/golftime-club-light.svg';

import { M } from 'utils/siteStyle';

const GolfClubLogo = ({ type, wrapperStyles, className }) => {
  const getGolfClubLogo = useMemo(() => {
    let Logo;
    switch (type) {
      case 'standard':
        Logo = ((M.SG || M.FOH || M.TWC) && SgGolfClubLogo) || (M.BT && GolftimeClubLogo);
        break;
      case 'reverse':
        Logo = ((M.SG || M.FOH || M.TWC) && SgGolfClubReverse) || (M.BT && GolftimeClubReverse);
        break;
      case 'light':
        Logo = ((M.SG || M.FOH || M.TWC) && SgGolfClubLight) || (M.BT && GolftimeClubLight);
        break;
      default:
        Logo = ((M.SG || M.FOH || M.TWC) && SgGolfClubLogo) || (M.BT && GolftimeClubLogo);
    }

    return <Logo className={className} />;
  }, [type, className]);

  return (
    <div className={wrapperStyles}>{getGolfClubLogo}</div>
  );
};

GolfClubLogo.defaultProps = {
  type: 'standard',
  wrapperStyles: '',
  className: '',
};

GolfClubLogo.propTypes = {
  type: PropTypes.string,
  wrapperStyles: PropTypes.string,
  className: PropTypes.string,
};

export default GolfClubLogo;
